/**
 * Intelligent Mail barcode (IMb) helpers — the 31-digit USPS barcode printed
 * beneath a mail piece. Pure + dependency-free (no React, no UI) so both client
 * features and server-side validators can share one definition.
 */
export const IMB_LENGTH = 31;

const IMB_RE = /^[0-9]{31}$/;

/** Strip spaces and dashes so a pasted / QR-scanned IMb still validates. */
export function normalizeImb(raw: string): string {
  return raw.replace(/[\s-]/g, "");
}

/** True when `value` normalizes to exactly 31 digits. */
export function isValidImb(value: string): boolean {
  return IMB_RE.test(normalizeImb(value));
}
